<script lang="ts">
	import {
		Breadcrumbs,
		BreadcrumbsFlexWrapper,
		Input,
		Toolbar,
	} from '@Shelly/shelly-design-system/index';
	import AddEditButtons from 'src/components/AddEditButtons.svelte';
	import { isSubAccount } from 'src/helpers/user_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { is_mobile } from 'src/stores/ui/viewport';
	import { edit } from 'src/stores/ui/edit_lists';
	import { roomMainFilter } from 'src/stores/ui/filters';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { format } from 'svelte-i18n';

	export let onShowAddEditModal;
	export let itemsLength = 0;
</script>

<Toolbar class="mb-m" isSticky useNewLayout hideSlotLeftSide={$edit} hideSlotRightSide={$is_mobile}>
	<BreadcrumbsFlexWrapper slot="breadcrumbs" gap="s" hideSlotRight={isSubAccount() || !$is_mobile}>
		<Breadcrumbs
			slot="left"
			class="flex-1 min-width-0 max-width-fit-content"
			listClasses="width-full"
			aria-label={$format('label_rooms', { default: 'Rooms' })}
			links={[{ label: capFirstChar($format('tab_rooms', { default: 'Rooms' })) }]}
		/>
		<AddEditButtons
			slot="right"
			on:add_click={async () => {
				onShowAddEditModal();
			}}
			disableEditButton={itemsLength <= 1}
			hideAddButton
			context="rooms"
		/>
	</BreadcrumbsFlexWrapper>
	<svelte:fragment slot="leftSide">
		<Input
			class="text-capitalize-placeholder width-md-l"
			bind:value={$roomMainFilter}
			type="text"
			label={capFirstChar($format('search', { default: 'Search' }))}
			icon="fas fa-search"
			id="rooms-toolbar-search-input"
			aria-labelledby="rooms-toolbar-search-input"
		/>
	</svelte:fragment>
	<svelte:fragment slot="rightSide">
		{#if !isSubAccount() && (($showNewLayout && !$is_mobile) || !$showNewLayout)}
			<AddEditButtons
				on:add_click={async () => {
					onShowAddEditModal();
				}}
				disableEditButton={itemsLength <= 1}
				hideAddButton={$showNewLayout}
				context="rooms"
			/>
		{/if}
	</svelte:fragment>
</Toolbar>
